import { Outlet } from "react-router-dom";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Modal from "../components/modal/Modal";
import { useState } from "react";

export const UserLayout = () => {  
  const [isModalOpen, setModalOpen] = useState(false);
  
    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);
  return (
    <>
      <Header  openModal={openModal}/>
      <Outlet />
      <Footer/>
      <Modal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};
